import { all, call, spawn } from 'redux-saga/effects'

import authRootSaga from '@/redux/auth/sagas'
import exercisesRootSaga from '@/redux/exercises/sagas'
import patientsRootSaga from '@/redux/patients/sagas'
import schedulesSaga from '@/redux/schedules/sagas'
import scheduleTemplatesSaga from '@/redux/scheduleTemplates/sagas'
import userRootSaga from '@/redux/user/sagas'

function * rootSaga () {
  const sagas = [
    authRootSaga,
    userRootSaga,
    patientsRootSaga,
    exercisesRootSaga,
    schedulesSaga,
    scheduleTemplatesSaga
  ]

  yield all(
    sagas.map((saga) =>
      spawn(function * () {
        while (true) {
          try {
            yield call(saga)
            break
          } catch (e) {
            console.error(e)
          }
        }
      })
    )
  )
}

export default rootSaga
